import  { useState } from "react";
import {
  Box,
  Typography,
  Button,
  useTheme,

  IconButton,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowBack, SwapHoriz } from "@mui/icons-material";
import Logincomponnet from "../components/LoginComponet";
import SubUserLoginComponent from "../components/SubUserLoginComponent";
import Layout from "../components/layout/LandingPageLayout";

const Login = () => {
  const theme = useTheme();
  const [currentView, setCurrentView] = useState("main");

  const toggleView = () => {
    setCurrentView(currentView === "main" ? "sub" : "main");
  };

  const goBack = () => {
    setCurrentView("main");
  };

  const slideVariants = {
    hidden: { x: currentView === "sub" ? 100 : -100, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
    exit: {
      x: currentView === "sub" ? -100 : 100,
      opacity: 0,
      transition: {
        duration: 0.2,
        ease: "easeIn",
      },
    },
  };

  const logoVariants = {
    initial: { scale: 1, rotate: 0 },
    animate: {
      scale: [1, 1.05, 1],
      rotate: [0, 2, -2, 0],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
  };

  return (
    <Layout>
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          background: theme.palette.background.default,
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            height: "100%",
            background:
              theme.palette.mode === "dark"
                ? `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.main} 100%)`
                : `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.light} 100%)`,
            display: {
              xs: currentView === "main" ? "none" : "flex",
              md: "flex",
            },
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 0%, transparent 50%), 
                             radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 0%, transparent 50%)`,
            }}
          />

          <Box
            sx={{
              textAlign: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Box
              component={motion.div}
              variants={logoVariants}
              initial="initial"
              animate="animate"
              sx={{
                width: { xs: 120, md: 150, lg: 180 },
                height: { xs: 120, md: 150, lg: 180 },
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(10px)",
                border: "2px solid rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 4,
                mx: "auto",
              }}
            >
              <img
                src="/failogo.jpg"
                alt="Logo"
                style={{ height: "200px", width: "200px", marginRight: "8px" }}
              />
            </Box>

            {/* Company Info */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="h2"
                    component="span"
                    sx={{
                      color: "black",
                      fontSize: { xs: "4rem", md: "5rem", lg: "6rem" },
                      fontWeight: "300",
                    }}
                  >
                    f-
                  </Typography>
                  <Typography
                    variant="h2"
                    component="span"
                    sx={{
                      color: theme.palette.primary.main,
                      fontSize: { xs: "3rem", md: "4rem", lg: "5rem" },
                      fontWeight: "300",
                    }}
                  >
                    ai
                  </Typography>
                  <Typography
                    variant="h2"
                    component="span"
                    sx={{
                      color: "black",
                      fontSize: { xs: "3rem", md: "4rem", lg: "5rem" },
                      fontWeight: "300",
                    }}
                  >
                    .in
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                mb: 1,
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Secure Access Portal
            </Typography>
            <Box
              component={motion.div}
              animate={{
                opacity: [0.6, 1, 0.6],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontStyle: "italic",
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  mb: 3,
                }}
              >
                Simplify Your Finances with AI-Powered Accounting
              </Typography>
            </Box>

            <Box sx={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                onClick={toggleView}
                startIcon={<SwapHoriz />}
                component={motion.button}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                size="large"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.5)",

                  px: 4,
                  py: 1.5,
                  borderWidth: 2,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(10px)",
                  "&:hover": {
                    borderColor: "rgba(255, 255, 255, 0.8)",
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    borderWidth: 2,
                  },
                }}
              >
                {currentView === "main"
                  ? "Switch to Sub Portal"
                  : "Switch to Main Portal"}
              </Button>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            height: "100%",
            background: theme.palette.background.paper,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            p: "2%",
          }}
        >
          <Box
            sx={{
              mb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              height: "auto",
            }}
          >
            <AnimatePresence mode="wait">
              {currentView === "sub" && (
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.2 }}
                >
                  <IconButton
                    onClick={goBack}
                    sx={{
                      color: theme.palette.primary.main,
                      "&:hover": {
                        backgroundColor: theme.palette.action.hover,
                      },
                    }}
                  >
                    <ArrowBack />
                  </IconButton>
                </motion.div>
              )}
            </AnimatePresence>
          </Box>

          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <AnimatePresence mode="wait">
              {currentView === "main" && (
                <motion.div
                  key="main"
                  variants={slideVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  style={{ height: "100%", width: "100%" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component={motion.div}
                      whileHover={{ scale: 1.02, y: -4 }}
                      whileTap={{ scale: 0.98 }}
                      sx={{
                        width: "100%",
                        minHeight: { xs: 200, lg: 250 },
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        borderRadius: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        position: "relative",
                        overflow: "hidden",
                        boxShadow: theme.shadows[8],
                        "&:hover": {
                          boxShadow: theme.shadows[16],
                        },
                      }}
                    >
                      <Box sx={{ textAlign: "center", color: "white" }}>
                        <Logincomponnet />
                      </Box>
                    </Box>
                  </Box>
                </motion.div>
              )}

              {currentView === "sub" && (
                <motion.div
                  key="sub"
                  variants={slideVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  style={{ height: "100%", width: "100%" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component={motion.div}
                      whileHover={{ scale: 1.02, y: -4 }}
                      whileTap={{ scale: 0.98 }}
                      sx={{
                        width: "100%",
                        minHeight: { xs: 200, lg: 250 },
                        background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`,
                        borderRadius: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        position: "relative",
                        overflow: "hidden",
                        boxShadow: theme.shadows[8],
                        "&:hover": {
                          boxShadow: theme.shadows[16],
                        },
                      }}
                    >
                      <Box sx={{ textAlign: "center", color: "white" }}>
                        <SubUserLoginComponent />
                      </Box>
                    </Box>
                  </Box>
                </motion.div>
              )}
            </AnimatePresence>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Login;
